/**
 * Kalkulator białka DNŻ: warstwa strony.
 *
 * Skrypt niczego nie dorenderowuje - pola, tabelka przykładowa, cała tabela
 * produktów i teksty stoją w źródle HTML. Tutaj dzieje się tylko przeliczanie
 * na bieżąco, przełączanie stanu A/B panelu wyniku, synchronizacja suwaków
 * z polami, dieta roślinna w tabeli (D7) oraz przyklejany pasek nawigacji
 * ze scrollspy (1:1 ze spalania).
 *
 * Wszystkie obliczenia robi protein-calculator-logic.js (window.DnnzProteinLogic),
 * a liczby przychodzą z konfiguracji osadzonej w <script type="application/json">.
 * Zdania, w które wstawiamy liczby, czytamy z atrybutów data-* szablonu.
 *
 * Stan nie jest nigdzie zapisywany: ani w adresie, ani w magazynie przeglądarki.
 *
 * Vanilla JS, bez jQuery.
 */
(function () {
	'use strict';

	/**
	 * Pozycja wartości na torze suwaka - odpowiednik fill_percent() w PHP.
	 */
	function fillPercent(value, min, max) {
		if (!(max > min)) {
			return 0;
		}
		return Math.min(100, Math.max(0, ((value - min) / (max - min)) * 100));
	}

	function toggle(element, visible) {
		if (element) {
			element.hidden = !visible;
		}
	}

	function initCalculator(root, L) {
		var configEl = root.querySelector('[data-role="config"]');
		if (!configEl) {
			return;
		}

		var cfg;
		try {
			cfg = JSON.parse(configEl.textContent);
		} catch (e) {
			return;
		}

		var emptyState = root.querySelector('[data-state="empty"]');
		var valueState = root.querySelector('[data-state="value"]');
		if (!emptyState || !valueState) {
			return;
		}

		// Pola liczbowe z suwakami: masa, wiek, wzrost.
		function numeric(name) {
			return {
				number: root.querySelector('[data-role="' + name + '-number"]'),
				range: root.querySelector('[data-role="' + name + '-range"]'),
				fill: root.querySelector('[data-role="' + name + '-fill"]'),
				error: root.querySelector('[data-role="' + name + '-error"]'),
				limit: cfg.limits[name]
			};
		}

		var fields = {
			weight: numeric('weight'),
			age: numeric('age'),
			height: numeric('height')
		};

		var plantInput = root.querySelector('[data-role="plant"]');
		var sampleRows = Array.prototype.slice.call(root.querySelectorAll('[data-role="sample-row"]'));
		var captionEl = root.querySelector('[data-role="samples-caption"]');
		var proteinEl = root.querySelector('[data-role="protein"]');
		var conversionEl = root.querySelector('[data-role="conversion"]');
		var mealEl = root.querySelector('[data-role="meal"]');
		var liveEl = root.querySelector('[data-role="live"]');
		var groups = Array.prototype.slice.call(root.querySelectorAll('[data-role="group"]'));

		var captionTemplates = captionEl ? {
			base: captionEl.getAttribute('data-caption') || '',
			age: captionEl.getAttribute('data-caption-age') || '',
			plant: captionEl.getAttribute('data-caption-plant') || '',
			end: captionEl.getAttribute('data-caption-end') || ''
		} : null;

		var mealTemplates = mealEl ? {
			base: mealEl.getAttribute('data-meal-base') || '',
			lead: mealEl.getAttribute('data-meal-lead') || '',
			item: mealEl.getAttribute('data-meal-item') || '',
			comma: mealEl.getAttribute('data-meal-comma') || '',
			or: mealEl.getAttribute('data-meal-or') || '',
			end: mealEl.getAttribute('data-meal-end') || ''
		} : null;

		// Losowa kolejność obu pul powstaje raz, przy wejściu na stronę (D6).
		var picker = L.createExamplePicker(cfg, L.createRng(Math.floor(Math.random() * 4294967296)));

		// Ostatni poprawny wiek - tabelka stanu A nie gubi go, gdy pole jest
		// chwilowo puste albo wpisana wartość wychodzi poza zakres.
		var lastAge = L.parseNumber(fields.age.number ? fields.age.number.value : null);
		if (lastAge === null || isNaN(lastAge)) {
			lastAge = cfg.limits.age.default;
		}

		var lastPlant = plantInput ? plantInput.checked : false;

		// Pole "zatwierdzone" (change: wyjście z pola, Enter, suwak). W trakcie
		// pisania "100" pierwsze "1" jest poza zakresem - komunikat o zbyt małej
		// wartości czeka na zatwierdzenie, żeby nie migał i nie przesuwał
		// formularza. Wartość za dużą albo nieliczbową pokazujemy od razu,
		// bo dopisanie kolejnej cyfry jej nie naprawi.
		var committed = { weight: true, age: true, height: true };

		function showError(name, raw, hasError) {
			if (!hasError) {
				return false;
			}
			if (committed[name]) {
				return true;
			}
			var value = L.parseNumber(raw);
			return value !== null && (isNaN(value) || value > fields[name].limit.max);
		}

		function checkedValue(role) {
			var input = root.querySelector('[data-role="' + role + '"]:checked');
			return input ? input.value : null;
		}

		/**
		 * Suwak i pole liczbowe to jedna wartość w dwóch kontrolkach. Pusta
		 * wartość = suwak neutralny: pusty tor, wyszarzona gałka.
		 */
		function syncSlider(field, value) {
			if (field.range) {
				field.range.classList.toggle('is-empty', value === null);
				if (value !== null) {
					field.range.value = Math.min(field.limit.max, Math.max(field.limit.min, Math.round(value)));
					field.range.setAttribute('aria-valuetext', String(value).replace('.', ','));
				} else {
					field.range.setAttribute('aria-valuetext', 'nie podano');
				}
			}
			if (field.fill) {
				field.fill.style.width = value === null ? '0%' : fillPercent(value, field.limit.min, field.limit.max) + '%';
			}
		}

		function updateSamples(evaluation, choices) {
			var rows = evaluation.samples.rows;

			sampleRows.forEach(function (row, index) {
				var cell = row.querySelector('[data-role="sample-protein"]');
				if (cell && rows[index]) {
					cell.textContent = rows[index].protein;
				}
			});

			if (captionEl && captionTemplates) {
				captionEl.textContent = L.samplesCaption({
					goal: choices.goal,
					activity: choices.activity,
					age: evaluation.sampleAge
				}, evaluation.samples, captionTemplates, cfg);
			}
		}

		/** Linia posiłku z odcinków: tekst albo link do wpisu bazy produktów. */
		function renderMeal(parts) {
			while (mealEl.firstChild) {
				mealEl.removeChild(mealEl.firstChild);
			}
			parts.forEach(function (part) {
				if (part.link) {
					var a = document.createElement('a');
					a.href = part.link.href;
					a.textContent = part.link.text;
					mealEl.appendChild(a);
				} else {
					mealEl.appendChild(document.createTextNode(part.text));
				}
			});
		}

		/**
		 * Dieta roślinna w tabeli produktów (D7): zostają dwie grupy roślinne,
		 * pierwsza z nich się otwiera. Po wyłączeniu wracają wszystkie grupy.
		 */
		function updateTable(plant) {
			var firstPlant = null;
			groups.forEach(function (group) {
				var isPlant = group.getAttribute('data-plant') === '1';
				toggle(group, !plant || isPlant);
				if (isPlant && !firstPlant) {
					firstPlant = group;
				}
			});
			if (plant && firstPlant) {
				firstPlant.open = true;
			}
		}

		function render() {
			var choices = {
				goal: checkedValue('goal'),
				activity: checkedValue('activity'),
				meals: checkedValue('meals'),
				plant: plantInput ? plantInput.checked : false
			};

			var evaluation = L.evaluate({
				weight: fields.weight.number.value,
				age: fields.age.number.value,
				height: fields.height.number.value,
				goal: choices.goal,
				activity: choices.activity,
				meals: choices.meals,
				plant: choices.plant
			}, cfg, lastAge);

			lastAge = evaluation.sampleAge;

			['weight', 'age', 'height'].forEach(function (name) {
				var field = fields[name];
				var read = L.readField(field.number.value, field.limit);
				var shown = showError(name, field.number.value, evaluation.errors[name]);
				toggle(field.error, shown);
				field.number.setAttribute('aria-invalid', shown ? 'true' : 'false');
				syncSlider(field, read.value);
			});

			updateSamples(evaluation, choices);

			if (choices.plant !== lastPlant) {
				updateTable(choices.plant);
				lastPlant = choices.plant;
			}

			var result = evaluation.result;

			if (result) {
				var examples = picker.pick(result.perMeal, choices.plant);

				if (proteinEl) {
					proteinEl.textContent = result.protein;
				}
				if (conversionEl) {
					var template = result.adjusted
						? conversionEl.getAttribute('data-template-adjusted')
						: conversionEl.getAttribute('data-template');
					conversionEl.textContent = L.fill(template || '', {
						dolny: result.rangeLow,
						gorny: result.rangeHigh,
						wsp: L.formatDecimal(result.coefficient),
						masa: result.weightDisplay
					});
				}
				if (mealEl && mealTemplates) {
					renderMeal(L.mealLine(result, examples, mealTemplates));
				}
			}

			toggle(emptyState, !result);
			toggle(valueState, !!result);

			if (liveEl) {
				liveEl.textContent = result
					? 'Wynik: ' + result.protein + ' g białka dziennie, zakres ' + result.rangeLow + ' do ' + result.rangeHigh + ' g.'
					: '';
			}
		}

		// Pola liczbowe: przeliczanie przy każdym znaku.
		['weight', 'age', 'height'].forEach(function (name) {
			var field = fields[name];
			if (!field.number) {
				return;
			}
			field.number.addEventListener('input', function () {
				committed[name] = false;
				render();
			});
			field.number.addEventListener('change', function () {
				committed[name] = true;
				render();
			});

			if (field.range) {
				field.range.addEventListener('input', function () {
					field.number.value = field.range.value;
					committed[name] = true;
					render();
				});
			}
		});

		// Wybory i przełącznik.
		Array.prototype.forEach.call(root.querySelectorAll('[data-role="goal"], [data-role="activity"], [data-role="meals"], [data-role="plant"]'), function (input) {
			input.addEventListener('change', render);
		});

		if (lastPlant) {
			updateTable(true);
		}
		render();
	}

	/**
	 * Przyklejany pasek nawigacji ze scrollspy - 1:1 ze spalania.
	 *
	 * Pozycję stałą włącza skrypt, a nie position: sticky - sticky przestaje
	 * działać na końcu sekcji bloku, więc pasek odjeżdżałby razem z tabelą,
	 * zamiast towarzyszyć dalszym sekcjom strony. W miejscu, z którego pasek
	 * wyskakuje z potoku, zostaje podstawka o jego wysokości.
	 */
	function initStickyNav(root) {
		var nav = root.querySelector('[data-role="nav"]');
		if (!nav) {
			return;
		}

		var header = document.querySelector('.site-header');
		var spacer = document.createElement('div');
		spacer.className = 'protein-calculator__nav-spacer';
		spacer.hidden = true;
		nav.parentNode.insertBefore(spacer, nav);

		var isFixed = false;
		var ticking = false;

		// Scrollspy: linki nawigacji i sekcje, do których prowadzą. Kotwice
		// spoza strony (np. sekcja jeszcze nieopublikowana) dają null i są
		// po prostu pomijane.
		var list = nav.querySelector('ul');
		var links = Array.prototype.slice.call(nav.querySelectorAll('a[href^="#"]'));
		var targets = links.map(function (link) {
			var id = link.getAttribute('href').slice(1);
			return id ? document.getElementById(id) : null;
		});
		var activeIndex = -1;

		function headerOffset() {
			if (!header) {
				return 0;
			}
			var position = window.getComputedStyle(header).position;
			if (position !== 'sticky' && position !== 'fixed') {
				return 0;
			}
			var rect = header.getBoundingClientRect();
			return rect.top <= 0 ? Math.max(0, Math.round(rect.bottom)) : 0;
		}

		/**
		 * Przewija pasek w poziomie tak, żeby aktywna pigułka była widoczna.
		 * Dotyczy tylko wąskich ekranów, gdzie lista się nie mieści.
		 */
		function keepVisible(link) {
			if (!list || list.scrollWidth <= list.clientWidth) {
				return;
			}

			// Liczymy na prostokątach, a nie na offsetLeft: przy pozycji stałej
			// offsetParent pigułki zmienia się na sam pasek i offsety
			// przestają odpowiadać przewijaniu listy.
			var item = link.parentNode.getBoundingClientRect();
			var box = list.getBoundingClientRect();
			var margin = 16;

			if (item.left < box.left + margin) {
				list.scrollLeft += item.left - box.left - margin;
			} else if (item.right > box.right - margin) {
				list.scrollLeft += item.right - box.right + margin;
			}
		}

		/**
		 * Aktywna jest ostatnia sekcja, której górna krawędź minęła linię tuż
		 * pod paskiem. Na samym dole strony wygrywa sekcja ostatnia - inaczej
		 * krótka sekcja końcowa nigdy nie doszłaby do tej linii.
		 */
		function updateActive(offset) {
			if (!links.length) {
				return;
			}

			var line = offset + (isFixed ? nav.getBoundingClientRect().height : 0) + 16;
			var current = -1;

			targets.forEach(function (target, index) {
				if (target && target.getBoundingClientRect().top <= line) {
					current = index;
				}
			});

			var atBottom = window.innerHeight + window.pageYOffset >= document.documentElement.scrollHeight - 2;
			if (atBottom) {
				for (var i = targets.length - 1; i >= 0; i--) {
					if (targets[i]) {
						current = i;
						break;
					}
				}
			}

			if (current === activeIndex) {
				return;
			}

			if (links[activeIndex]) {
				links[activeIndex].classList.remove('is-active');
				links[activeIndex].removeAttribute('aria-current');
			}

			activeIndex = current;

			if (links[activeIndex]) {
				links[activeIndex].classList.add('is-active');
				links[activeIndex].setAttribute('aria-current', 'true');
				keepVisible(links[activeIndex]);
			}
		}

		function update() {
			ticking = false;

			var offset = headerOffset();
			root.style.setProperty('--pc-sticky-top', offset + 'px');

			// Punkt odniesienia to naturalne miejsce paska w potoku; kiedy pasek
			// jest przyklejony, trzyma je podstawka.
			var top = (isFixed ? spacer : nav).getBoundingClientRect().top;

			if (!isFixed && top <= offset) {
				// Do wysokości doliczamy margines, bo element poza potokiem
				// przestaje go wnosić i treść pod paskiem podskoczyłaby.
				var margin = parseFloat(window.getComputedStyle(nav).marginBottom) || 0;
				spacer.style.height = nav.getBoundingClientRect().height + margin + 'px';
				spacer.hidden = false;
				nav.classList.add('is-fixed');
				isFixed = true;
			} else if (isFixed && top > offset) {
				nav.classList.remove('is-fixed');
				spacer.hidden = true;
				isFixed = false;
			}

			updateActive(offset);
		}

		function onScroll() {
			if (!ticking) {
				ticking = true;
				window.requestAnimationFrame(update);
			}
		}

		window.addEventListener('scroll', onScroll, { passive: true });
		window.addEventListener('resize', onScroll);
		window.addEventListener('load', onScroll);

		update();
	}

	function init() {
		var L = window.DnnzProteinLogic;
		var blocks = Array.prototype.slice.call(document.querySelectorAll('[data-protein-calculator]'));

		blocks.forEach(function (root) {
			if (L) {
				initCalculator(root, L);
			}
			initStickyNav(root);
		});
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', init);
	} else {
		init();
	}
})();
